/**
 * Combines strings separated by a space in the order in which they are provide
 * @param combineString String that will be used to concat the string
 * @param values Strings that need to be combined (order is important)
 * @returns Combined strings
 */
export const combineStrings = function (
  combineString: string | null | undefined,
  ...values: Array<string | null | undefined>
) {
  let result = '';

  if (combineString == null) return undefined;
  if (typeof combineString !== 'string') return undefined;

  for (const value of values) {
    if (value == null) continue;
    if (typeof value !== 'string') continue;
    if (value.trim() === '') continue;

    if (result != null && typeof result === 'string' && result.trim() !== '') result += combineString;
    result += value;
  }

  result = result.trim();

  if (result == null) return undefined;
  if (typeof result !== 'string') return undefined;
  if (result.trim() === '') return undefined;

  return result;
};
